import { useState } from 'react'
import { bool, object, oneOfType, string, number, func } from 'prop-types'
import Div from '@ui/layout/Div'
import Icon from '@ui/elements/Icon'
import ProgressBar from '@ui/elements/ProgressBar'

const ImageDropzone = ({ cssFigureClass = '', cssImageClass = '', uploadCallback, deleteCallback, image, index, uploadStarted, authorizedIndex, alt = '' }) => {
  const [progress, setProgress] = useState(0)
  const [tmpName, setTmpName] = useState(null)
  const deleteFile = e => {
    deleteCallback(e, image)
  }

  if (image.file) {
    const imageBlob = window.URL.createObjectURL(image.file)
    if (!image.serverId && tmpName) {
      image.serverId = tmpName
    }
    if (!uploadStarted && !image.serverId && authorizedIndex === index) {
      uploadCallback(image, index, setProgress, setTmpName)
    }
    return (
      <Div cssClass='imageDropzone'>
        <figure className={`image ${cssFigureClass}`}>
          <img src={imageBlob} className={cssImageClass} alt={alt} />
        </figure>
        <ProgressBar cssClass={`uploadProgress ${progress === 100 ? 'is-hidden' : ''}`} progress={progress} />
        <Icon icon='icon-cancel-circle' spanClass='deleteDroppedImage' callback={deleteFile} areaLabel='Delete uploaded image' />
      </Div>
    )
  } else {
    return (<></>)
  }
}

ImageDropzone.propTypes = {
  alt: string,
  authorizedIndex: oneOfType([number, bool]),
  cssFigureClass: string,
  cssImageClass: string,
  deleteCallback: func,
  image: object,
  index: number,
  uploadStarted: bool,
  uploadCallback: func
}

export default ImageDropzone
